
import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Offices = lazy(() => import(`Pages/Admin/Offices/Page`));

const OfficesRoutes: RouteObject[] = [
    {
        path: 'escritorios',
        element: <LoadComponent component={Offices} />,
    },
]

export default OfficesRoutes;
